import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { Router, RouterOutlet } from "@angular/router";
import { Amplify } from "aws-amplify";
import { cognitoUserPoolsTokenProvider } from "aws-amplify/auth/cognito";
import { CookieStorage } from "aws-amplify/utils";
import { authPaths } from "~modules/auth/auth.routes";
import { AuthService } from "~modules/auth/auth.service";
import { CQFooterComponent } from "~modules/shared/components/cq-footer/cq-footer.component";
import { CQHeaderComponent } from "~modules/shared/components/cq-header/cq-header.component";
import { DataSharingService } from "~modules/shared/services/data-sharing/data-sharing.service";
import {
  EventBusService,
  EventBusType,
} from "~modules/shared/services/event-bus/event-bus.service";
import { PdfDataService } from "~modules/shared/services/pdf-data/pdf-data.service";
import { getUserAttributeFromToken } from "~modules/shared/utils/helper";
import { environment } from "../environments/environment";
import { appPaths } from "./app.routes";

@Component({
  selector: "app-root",
  standalone: true,
  imports: [CommonModule, RouterOutlet, CQHeaderComponent, CQFooterComponent],
  templateUrl: "./app.component.html",
  styleUrl: "./app.component.scss",
})
export class AppComponent implements OnInit {
  title = "cq-configurator";
  isPdfExporting = false;
  pdfData = {
    projectName: "",
    dimensions: {},
    threeDContent: {},
    resultData: {},
    activeMenu: "",
  };

  constructor(
    private authService: AuthService,
    private router: Router,
    private eventBusService: EventBusService,
    private dataSharingService: DataSharingService,
    private pdfDataService: PdfDataService,
  ) {
    Amplify.configure({
      Auth: {
        Cognito: {
          userPoolId: environment.userPoolId,
          identityPoolId: environment.identityPoolId,
          userPoolClientId: environment.clientId,
          signUpVerificationMethod: "code",
          loginWith: {
            oauth: {
              domain: environment.domain,
              scopes: ["openid", "email", "profile", ...environment.scopes],
              redirectSignIn: [window.location.origin],
              redirectSignOut: [window.location.origin],
              responseType: "code",
              providers: [{ custom: "CovestroAzureSSO" }],
            },
          },
        },
      },
    });
    cognitoUserPoolsTokenProvider.setKeyValueStorage(new CookieStorage());

    this.checkAccessToken();
  }

  ngOnInit(): void {
    // Subscribe to PDF data changes
    this.pdfDataService.pdfData$.subscribe((data) => {
      this.pdfData = data;
    });

    // Subscribe to active menu changes
    this.dataSharingService.getActiveMenu().subscribe((activeMenu) => {
      this.pdfDataService.updateActiveMenu(activeMenu);
    });

    this.eventBusService.events$.subscribe((event) => {
      if (event.type === EventBusType.IS_EXPORTING_PDF) {
        this.isPdfExporting = true;
        // Extract data from DOM before PDF generation
        this.pdfDataService.extractDataFromDOM();
      } else if (event.type === EventBusType.DONE_EXPORTING_PDF) {
        this.isPdfExporting = false;
      }
    });
  }

  async checkAccessToken(): Promise<void> {
    try {
      const isLogin = await this.authService.isAuthenticated();

      if (!isLogin) {
        const route = `${appPaths.auth}/${authPaths.signIn}`;
        this.router.navigate([route]);
      } else {
        // const email = await getEmailFromToken();
        const { email, userGroups, roles, provider } =
          await getUserAttributeFromToken();
        this.authService.setUserEmail(email);
        this.authService.setUserGroup(userGroups);

        if (provider === "CovestroAzureSSO") {
          this.authService.setUserRoles("admin");
        } else {
          this.authService.setUserRoles(roles);
        }
      }
    } catch (err) {
      console.log(err);
    }
  }
}
